// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__Link from "../../html/Link.js";
import * as Buhta_cabinet__Route from "../../../Route.js";
import * as Buhta_cabinet__SidebarNestedItem from "./SidebarNestedItem.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__Tenant from "../../../../../../packages/core/lib/Tenant.js";
import * as Caml_format from "melange.js/caml_format.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function SidebarProfile(Props) {
  let currentRoute = Props.currentRoute;
  const currentUrl = Buhta_cabinet__Route.useUrl(undefined);
  const match = React.useState(function () {
    return false;
  });
  const setIsSettingsHovered = match[1];
  const isSettingsHovered = match[0];
  const match$1 = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match$1[0];
  const returnUrl = Belt__Belt_Option.getWithDefault(Buhta_cabinet__Route.getParamValue(currentUrl, "return_to", undefined), "/org");
  const org_id = returnUrl.slice(5, undefined);
  let orgId;
  try {
    orgId = Caml_format.caml_int_of_string(org_id);
  }
  catch (exn){
    orgId = 0;
  }
  const contextRoute = function (route) {
    return Buhta_cabinet__Route.contextRoute(tenant.ctx, orgId, route);
  };
  let tmp;
  if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string" || currentRoute.TAG !== /* Profile */ 5) {
    tmp = false;
  } else {
    switch (currentRoute._0) {
      case /* General */ 0 :
        tmp = true;
        break;
      case /* Security */ 1 :
      case /* API */ 2 :
        tmp = false;
        break;
    }
  }
  let tmp$1;
  if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string" || currentRoute.TAG !== /* Profile */ 5) {
    tmp$1 = false;
  } else {
    switch (currentRoute._0) {
      case /* Security */ 1 :
        tmp$1 = true;
        break;
      case /* General */ 0 :
      case /* API */ 2 :
        tmp$1 = false;
        break;
    }
  }
  let tmp$2;
  if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string" || currentRoute.TAG !== /* Profile */ 5) {
    tmp$2 = false;
  } else {
    switch (currentRoute._0) {
      case /* General */ 0 :
      case /* Security */ 1 :
        tmp$2 = false;
        break;
      case /* API */ 2 :
        tmp$2 = true;
        break;
    }
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Buhta_cabinet__Link.make, {
            route: /* OrgChoose */ 0,
            children: JsxRuntime.jsx("img", {
              alt: "logo",
              src: StaticAsset.src("/static/icons/logo.svg")
            })
          }),
          className: "cursor-pointer"
        }),
        className: "flex justify-between px-6 pt-0 items-center"
      }),
      JsxRuntime.jsx(Buhta_cabinet__Link.make, {
        route: Buhta_cabinet__Route.ofUrl(Buhta_cabinet__Route.getRouterUrl(returnUrl)),
        className: "px-6 mt-8 mb-6 flex justify-between",
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("img", {
              className: "w-5 h-5",
              src: StaticAsset.src("/static/icons/back-arrow.svg")
            }),
            JsxRuntime.jsx(Buhta_components__Text.H4.make, {
              className: "ml-4 text-white",
              children: "Профиль"
            })
          ],
          className: "flex items-center"
        })
      }),
      JsxRuntime.jsx(Buhta_cabinet__SidebarNestedItem.make, {
        isActive: tmp,
        route: {
          TAG: /* Profile */ 5,
          _0: /* General */ 0
        },
        activeIcon: JsxRuntime.jsx("img", {
          className: "w-5 h-5 shrink-0",
          src: StaticAsset.src("/static/icons/user-white-20.svg")
        }),
        icon: JsxRuntime.jsx("img", {
          className: "w-5 h-5 shrink-0",
          src: StaticAsset.src("/static/icons/user.svg")
        }),
        title: "Общая информация"
      }),
      JsxRuntime.jsx(Buhta_cabinet__SidebarNestedItem.make, {
        isActive: tmp$1,
        route: {
          TAG: /* Profile */ 5,
          _0: /* Security */ 1
        },
        activeIcon: JsxRuntime.jsx("img", {
          className: "w-5 h-5 shrink-0",
          src: StaticAsset.src("/static/icons/lock-white-20.svg")
        }),
        icon: JsxRuntime.jsx("img", {
          className: "w-5 h-5 shrink-0",
          src: StaticAsset.src("/static/icons/lock-gray-20.svg")
        }),
        title: "Безопасность"
      }),
      JsxRuntime.jsx(Buhta_cabinet__SidebarNestedItem.make, {
        isActive: tmp$2,
        route: {
          TAG: /* Profile */ 5,
          _0: /* API */ 2
        },
        activeIcon: JsxRuntime.jsx("img", {
          className: "w-5 h-5 shrink-0",
          src: StaticAsset.src("/static/icons/key-white-20.svg")
        }),
        icon: JsxRuntime.jsx("img", {
          className: "w-5 h-5 shrink-0",
          src: StaticAsset.src("/static/icons/key-gray-20.svg")
        }),
        title: "Ключи API"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs(Buhta_cabinet__Link.make, {
          route: contextRoute({
            TAG: /* Settings */ 8,
            _0: /* General */ 0
          }),
          className: Cn.fromList({
            hd: "whitespace-nowrap px-6 flex py-1.5 hover:w-full",
            tl: {
              hd: isSettingsHovered ? "bg-white/8" : "hover:bg-white/8",
              tl: /* [] */ 0
            }
          }),
          children: [
            isSettingsHovered ? JsxRuntime.jsx("img", {
                className: "w-5 h-5 shrink-0",
                src: StaticAsset.src("/static/icons/settings-white-20.svg")
              }) : JsxRuntime.jsx("img", {
                className: "w-5 h-5 shrink-0",
                src: StaticAsset.src("/static/icons/settings.svg")
              }),
            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
              className: Cn.fromList({
                hd: "ml-4 truncate",
                tl: {
                  hd: isSettingsHovered ? "text-white" : "text-gray-medium group-hover:text-white",
                  tl: /* [] */ 0
                }
              }),
              children: "Настройки"
            })
          ],
          onMouseEnter: (function (param) {
            Curry._1(setIsSettingsHovered, (function (param) {
              return true;
            }));
          }),
          onMouseLeave: (function (param) {
            Curry._1(setIsSettingsHovered, (function (param) {
              return false;
            }));
          })
        }),
        className: "absolute bottom-6 space-y-2 w-[244px]"
      })
    ],
    className: "flex flex-col bg-black py-6 relative border-r border-white/8 duration-500 transition-width ease-out w-61 overflow-y-auto"
  });
}

const make = SidebarProfile;

export {
  make,
}
/* Buhta_cabinet__Link Not a pure module */
